import { useEffect, useState } from "react";
import moment from "moment";

const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

const BusinessHours = ({ horarios, tipoHorario }) => {
    const [mostrarHorarios, setMostrarHorarios] = useState(false);
    const ahora = moment();
    const currentDay = diasSemana[ahora.day()];
    const [estadoActual, setEstadoActual] = useState({ abierto: false, mensaje: "" });

  useEffect(() => {
    if (tipoHorario === 1) {
      setEstadoActual({ abierto: true, mensaje: "SIEMPRE ABIERTO" });
      return;
    }

    const now = moment();
    const diaActual = diasSemana[now.day()];
    const hoy = horarios.find((h) => h.dia === diaActual);

    if (!hoy || hoy.cerrado === 1) {
      setEstadoActual({ abierto: false, mensaje: "CERRADO" });
      return;
    }

    const horaInicio = moment(hoy.inicio, "HH:mm:ss");
    const horaFin = moment(hoy.fin, "HH:mm:ss");

    if (now.isBetween(horaInicio, horaFin)) {
      const diferencia = horaFin.diff(now, "minutes");
      if (diferencia <= 60) {
        setEstadoActual({ abierto: true, mensaje: `Cierra pronto a las ${horaFin.format("h:mm a")}` });
      } else {
        setEstadoActual({ abierto: true, mensaje: `Cierra a las ${horaFin.format("h:mm a")}` });
      }
    } else {
      setEstadoActual({ abierto: false, mensaje: "CERRADO" });
    }
  }, [horarios, tipoHorario]);

  return (
    <div className="business-hours" style={{ flexDirection: "column" }}>
      <div className={`hours-header ${mostrarHorarios ? "active" : ""}`}  style={{ paddingBottom: estadoActual.mensaje === "SIEMPRE ABIERTO" ? "15px" : "0px"}} onClick={() => setMostrarHorarios(!mostrarHorarios)}>
        <div>
          <svg className="clock-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1">
              <circle cx="12" cy="12" r="9" />
              <path d="M11 8v5h5" />
            </g>
          </svg>
        </div>
        <div className="hours-info">
          {estadoActual.abierto ? (
            <>
              <span className="open-now">Abierto ahora</span>
              <span className="closing-time">{estadoActual.mensaje}</span>
            </>
          ) : (
            <span className="closed">{estadoActual.mensaje}</span>
          )}
        </div>
        {tipoHorario !== 1 && (
          <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor" d="m12 15l-5-5h10z" />
          </svg>
        )}
      </div>
      {tipoHorario !== 1 && (
        <div className={`hours-list ${mostrarHorarios ? "active" : ""}`}>
            {horarios.map((h, index) => {
            const esHoy = h.dia === currentDay;
            const inicio = moment(h.inicio, "HH:mm:ss").format("h:mm a");
            const fin = moment(h.fin, "HH:mm:ss").format("h:mm a");

            return (
                <div className="hour-item" key={index}>
                <span className={esHoy ? "current-day" : ""}>{h.dia}</span>
                {h.cerrado === 1 ? (
                    <span className="closed">CERRADO</span>
                ) : (
                    <span className={esHoy ? "current-day" : ""}>{`${inicio} - ${fin}`}</span>
                )}
                </div>
            );
            })}
        </div>
        )}
    </div>
  );
};

export default BusinessHours;
